import React, { useState } from 'react';
import Header from './components/Header';
import ColorGrid from './components/ColorGrid';
import ImagePreview from './components/ImagePreview';
import './styles/App.css';

function App() {
  const [selectedImage, setSelectedImage] = useState(null);
  
  const handleImageSelect = (image) => {
    setSelectedImage(image);
  };
  
  const handleClosePreview = () => {
    setSelectedImage(null);
  };

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <ColorGrid onImageSelect={handleImageSelect} />
        {selectedImage && (
          <ImagePreview 
            image={selectedImage} 
            onClose={handleClosePreview} 
          />
        )}
      </main>
      <footer className="footer">
        <p>© {new Date().getFullYear()} Color Backgrounds | All images for educational use only</p>
      </footer>
    </div>
  );
}

export default App; 